import React from 'react';
import {
    DateRow,
    EditWithIcon,
    FilterTags,
    HtmlConvertor,
    NameAndFolder,
    SimpleTooltip,
    SkillCard,
    TagComponent,
    TextRow,
} from 'components';
import { goalTypes } from 'fragments';
import { goalDataTypeEnums, goalDataTypes, Images, renderGoalTypes, stripHtml, tagEnums } from 'utils';
import { canReadTags } from 'store/tags/tag.utils';

export const libraryTabEnums = {
    GOALS: 'GOALS',
    TARGETS: 'TARGETS',
    OPTIONS: 'OPTIONS',
};
export const libraryTabTypes = [
    { title: 'Goals', tabValue: libraryTabEnums.GOALS },
    { title: 'Targets', tabValue: libraryTabEnums.TARGETS },
    { title: 'Options', tabValue: libraryTabEnums.OPTIONS },
];

export const ACTION_TYPE = 'GET_LIBRARY_GOALS';
export const ACTION_TYPE_DELETE_LIBRARY_GOAL = 'DELETE_LIBRARY_GOAL';

export const ACTION_TYPE_DELETE_LIBRARY_FOLDER = 'DELETE_LIBRARY_FOLDER';

export const goalsNotYet = {
    title: 'No Goals Yet.',
    subTitle: 'Your library is empty. Please create a goal.',
    btnText: 'Create Goal',
    image: Images.noClientYet,
};

export const goalsHead = (domainList, hasPermission) => [
    { name: 'name', searchKey: 'name', title: 'Goal Name' },
    { name: 'createdAt', title: 'Created Date', disabled: true },
    { name: 'creator', title: 'Creator', disabled: true },
    {
        name: 'domains',
        rowName: 'name',
        title: 'Domain',
        disabled: true,
        multiple: true,
        filterList: [{ name: 'All', id: 'All' }, ...domainList],
    },
    {
        name: 'goalType',
        title: 'Type',
        disabled: true,
        filterList: [{ name: 'All', id: 'All' }, ...goalTypes.map((goal) => ({ id: goal.id, name: goal.label }))],
    },
    canReadTags() && { name: '', title: 'Tags', custom: false, renderView: <FilterTags /> },
    {
        name: 'dataTypes',
        title: 'Data Collection Method',
        disabled: true,
        multiple: true,
        filterList: [{ name: 'All', id: 'All' }, ...goalDataTypes.map((goalType) => ({ id: goalType.id, name: goalType.label }))],
    },
    hasPermission && { name: '', title: 'Action', custom: false, width: '160px' },
];

export const goalsBody = (renderParams, hasPermission) => [
    { rowText: (item) => <NameAndFolder name={item.name} background={'#E6F5EE'} /> },
    { rowText: (item) => <DateRow date={item?.createdAt} /> },
    { rowText: (item) => <TextRow name={item?.creator} /> },
    { rowText: (item) => <TextRow name={item?.domain?.name} /> },
    { rowText: (item) => <SkillCard type={item?.type} /> },
    canReadTags() && {
        rowText: (item) => <TagComponent userInfo={item} module={tagEnums.LIBRARY_GOAL} requestParams={renderParams} />,
        notClickable: true,
    },
    {
        rowText: (item) => <TextRow name={renderGoalTypes(item?.dataType)} />,
    },
    hasPermission && {
        button: (fn) => (
            <div className="flex-align-center" style={{ gap: 8 }}>
                <EditWithIcon
                    id={'duplicate-form'}
                    icon={Images.duplicate}
                    type={'button'}
                    handleClick={(e) => {
                        fn('clone');
                        e.stopPropagation();
                    }}
                />
                <EditWithIcon
                    id={'edit-form'}
                    icon={Images.editAuth}
                    type={'button'}
                    handleClick={(e) => {
                        fn('edit');
                        e.stopPropagation();
                    }}
                />
                <EditWithIcon
                    id={'delete-form'}
                    icon={Images.deleteTag}
                    type={'button'}
                    handleClick={(e) => {
                        fn('delete');
                        e.stopPropagation();
                    }}
                />
            </div>
        ),
    },
];

export const targetsTabTableInfo = ({ handleAction }) => {
    return {
        loadingType: 'GET_LIBRARY_FOLDERS',
        head: [
            { name: 'name', title: 'Target Group Name', searchKey: 'name', width: '17%' },
            { name: 'createdAt', title: 'Created Date', disabled: true, width: '10%' },
            { name: 'creator', title: 'Creator', custom: false, disabled: true, width: '12%' },
            {
                name: 'dataTypes',
                title: 'Data Collection Method',
                disabled: true,
                multiple: true,
                filterList: [{ name: 'All', id: 'All' }, ...goalDataTypes.map((goalType) => ({ id: goalType.id, name: goalType.label }))],
                width: '14%',
            },
            {
                name: 'goalType',
                title: 'Type',
                disabled: true,
                filterList: [{ name: 'All', id: 'All' }, ...goalTypes.map((goal) => ({ id: goal.id, name: goal.label }))],
                width: '12%',
            },
            { name: 'description', title: 'Description', custom: false, disabled: true, width: '25%' },
            { name: '', title: 'Action', custom: false, width: '10%' },
        ],

        body: (item) => {
            return [
                {
                    value: (
                        <NameAndFolder
                            name={item.name}
                            background={'#E7F0FC'}
                            filter={
                                'brightness(0) saturate(100%) invert(23%) sepia(60%) saturate(6129%) hue-rotate(209deg) brightness(99%) contrast(91%)'
                            }
                        />
                    ),
                    width: '17%',
                },
                { value: <DateRow date={item?.createdAt} />, width: '10%' },
                { value: <TextRow name={item?.creator} />, width: '12%' },
                { value: <TextRow name={renderGoalTypes(item?.dataType)} />, width: '14%' },
                { value: <SkillCard type={item?.goalType} />, width: '12%' },
                { value: <HtmlConvertor text={item?.description} />, width: '25%' },
                {
                    value: (
                        <div className="flex-align-center" style={{ gap: 12 }}>
                            <EditWithIcon
                                id={'edit-form'}
                                icon={Images.editAuth}
                                type={'button'}
                                handleClick={(e) => {
                                    handleAction?.(item, 'edit');
                                    e.stopPropagation();
                                }}
                            />

                            <EditWithIcon
                                id={'delete-form'}
                                icon={Images.deleteTag}
                                type={'button'}
                                handleClick={(e) => {
                                    handleAction?.(item, 'delete');
                                    e.stopPropagation();
                                }}
                            />
                        </div>
                    ),
                    width: '10%',
                },
            ];
        },

        notYet: {
            title: 'No Targets Yet.',
            subTitle: 'Your library is empty. Please create a targets.',
            image: Images.noClientYet,
        },
    };
};

export const targetDetailsNotYet = {
    title: 'No Targets Yet.',
    subTitle: 'Your library is empty. Please create a targets.',
    btnText: 'Add Target',
    image: Images.noClientYet,
};

export const OptionDetailsNotYet = {
    title: 'No Options Yet.',
    subTitle: 'Your library is empty. Please create a options.',
    btnText: 'Add Option',
    image: Images.noClientYet,
};

export const optionsTabTableInfo = ({ handleAction }) => {
    return {
        loadingType: 'GET_LIBRARY_FOLDERS',
        head: [
            { name: 'name', title: 'Folder Name', searchKey: 'name', width: '17%' },
            { name: 'createdAt', title: 'Created Date', disabled: true, width: '10%' },
            { name: 'creator', title: 'Creator', custom: false, disabled: true, width: '12%' },
            {
                name: 'dataType',
                title: 'Data Collection Method',
                disabled: true,
                filterList: [
                    { name: 'All', id: 'All' },
                    ...goalDataTypes
                        .filter((d) => d.id === goalDataTypeEnums.PERCENT || d.id === goalDataTypeEnums.RATING)
                        .map((goalType) => ({ id: goalType.id, name: goalType.label })),
                ],
                width: '14%',
            },
            { name: 'description', title: 'Description', custom: false, disabled: true, width: '37%' },
            { name: '', title: 'Action', custom: false, width: '10%' },
        ],

        body: (item, index) => {
            return [
                {
                    value: (
                        <NameAndFolder
                            name={item.name}
                            background={'#FCF0E6'}
                            filter={
                                'brightness(0) saturate(100%) invert(39%) sepia(67%) saturate(2231%) hue-rotate(12deg) brightness(89%) contrast(98%)'
                            }
                        />
                    ),
                    width: '17%',
                },
                { value: <DateRow date={item?.createdAt} />, width: '10%' },
                { value: <TextRow name={item?.creator} />, width: '12%' },
                { value: <TextRow name={renderGoalTypes(item?.dataType)} />, width: '14%' },
                { value: <HtmlConvertor text={item?.description} />, width: '37%' },
                {
                    value: (
                        <div className="flex-align-center" style={{ gap: 12 }}>
                            <EditWithIcon
                                id={'edit-form'}
                                icon={Images.editAuth}
                                type={'button'}
                                handleClick={(e) => {
                                    handleAction?.(item, 'edit');
                                    e.stopPropagation();
                                }}
                            />

                            <EditWithIcon
                                id={'delete-form'}
                                icon={Images.deleteTag}
                                type={'button'}
                                handleClick={(e) => {
                                    handleAction?.(item, 'delete');
                                    e.stopPropagation();
                                }}
                            />
                        </div>
                    ),
                    width: '10%',
                },
            ];
        },

        notYet: {
            title: 'No Options Yet.',
            subTitle: 'Your library is empty. Please create a Options',
            image: Images.noClientYet,
        },
    };
};
